var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 317.18 373.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.95,
    y1: 348.38,
    x2: 96.47,
    y2: 186.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 24.95,
    x2: 96.47,
    y2: 186.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 292.22,
    y1: 22.27,
    x2: 292.22,
    y2: 186.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 292.22,
    y1: 348.38,
    x2: 292.22,
    y2: 186.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.47,
    y1: 24.95,
    x2: 292.22,
    y2: 24.95
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "297.17 47.1 287.58 32.27 270.08 29.9 284.91 20.31 287.28 2.81 296.87 17.64 314.36 20.01 299.54 29.6 297.17 47.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "297.17 208.81 287.58 193.98 270.08 191.61 284.91 182.02 287.28 164.52 296.87 179.35 314.36 181.72 299.54 191.31 297.17 208.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "297.17 370.52 287.58 355.69 270.08 353.32 284.91 343.73 287.28 326.24 296.87 341.06 314.36 343.43 299.54 353.02 297.17 370.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.42 47.1 91.83 32.27 74.33 29.9 89.16 20.31 91.53 2.81 101.12 17.64 118.62 20.01 103.79 29.6 101.42 47.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.42 208.81 91.83 193.98 74.33 191.61 89.16 182.02 91.53 164.52 101.12 179.35 118.62 181.72 103.79 191.31 101.42 208.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.9 370.52 20.31 355.69 2.81 353.32 17.64 343.73 20.01 326.24 29.6 341.06 47.1 343.43 32.27 353.02 29.9 370.52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheTower);
export default __webpack_public_path__ + "static/media/TheTower.af784fd35fba78e3a70c69342f37eff7.svg";
export { ForwardRef as ReactComponent };